module.exports = __webpack_public_path__ + "static/media/SDFSA_8-682w.63e90f66.jpg";